import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
const Svg = styled.svg.withConfig({
  displayName: "shape-document__Svg",
  componentId: "sc-13wf22p-0"
})(["enable-background:new 0 0 40 40;.st3,.st4{fill:none;stroke:", ";stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}.st4{stroke-width:0.4;}"], p => p.color);
export default (({
  color = 'currentColor'
}) => /*#__PURE__*/React.createElement(Svg, {
  viewBox: "0 0 40 40",
  color: color
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M31,11V29c0,1.1-0.9,2-2,2H11c-1.1,0-2-0.9-2-2V11c0-1.1,0.9-2,2-2H29C30.1,9,31,9.9,31,11z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: "23.5",
  y1: "13.7",
  x2: "26.3",
  y2: "13.7"
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: "23.5",
  y1: "15.1",
  x2: "26.3",
  y2: "15.1"
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: "26.3",
  y1: "16.5",
  x2: "23.5",
  y2: "16.5"
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "26.3,21.4 26.3,18.6 23.5,18.6 23.5,21.4 23.5,23.5 23.5,26.3 26.3,26.3 26.3,23.5 \t\t"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: "18.6",
  y: "13.7",
  className: "st4",
  width: "2.8",
  height: "2.8"
}), /*#__PURE__*/React.createElement("rect", {
  x: "13.7",
  y: "13.7",
  className: "st4",
  width: "2.8",
  height: "2.8"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "13.7,18.6 16.5,18.6 18.6,18.6 21.4,18.6 \t\t\t"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "13.7,20 16.5,20 18.6,20 21.4,20 \t\t\t"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "13.7,21.4 16.5,21.4 18.6,21.4 21.4,21.4 \t\t\t"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "13.7,23.5 16.5,23.5 18.6,23.5 21.4,23.5 \t\t"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "13.7,24.9 16.5,24.9 18.6,24.9 21.4,24.9 \t\t"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "21.4,26.3 18.6,26.3 16.5,26.3 13.7,26.3 \t\t"
})))));